import { React, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useGetAssignmentVocabularyMutation } from '../../../../../../features/authentication/assignApiSlice';
import { useAssignmentContext } from '../../../../context';
import HesSpinner from '../../../../../../components/loadingOverlay/hesSpinner';
import html2pdf from 'html2pdf.js';

const VocabularyStudySheet = () => {
  const { assignmentId } = useAssignmentContext();
  const navigate = useNavigate();
  const [assignmentVocabulary] = useGetAssignmentVocabularyMutation();
  const [vocabulary, setVocabulary] = useState({});
  const [vocabularyData, setVocabularyData] = useState([]);
  const [pageLoader, setPageLoader] = useState(true);

  useEffect(() => {
    getAssignmentVocabularyAsync();
  }, []);
  
  const getAssignmentVocabularyAsync = async () => {
    const options = {
      assignmentId: assignmentId
    };
    const getAssignmentVocabularyresponse = await assignmentVocabulary(options).unwrap();

    setVocabulary(getAssignmentVocabularyresponse);
    setVocabularyData(getAssignmentVocabularyresponse.vocabularyInfo);
    setPageLoader(false);
  };

  const handlePrint = async () => {
    const contentWrapper = document.getElementById('session_pdf_Wrapper');
    const contentClone = contentWrapper.cloneNode(true);
    const printButton = contentClone.querySelector('#print_button');
    const backButton = contentClone.querySelector('#back_button');
    printButton.style.display = 'none';
    backButton.style.display = 'none';

    const options = {
      margin: 40, // Specify the margin for all sides (top, right, bottom, left)
      image: { type: 'jpeg', quality: 0.98 }, // Set the image type and quality (optional)
      html2canvas: { scale: 2, backgroundColor: null }, // Set the scale for better quality (optional)
      jsPDF: { unit: 'pt', format: 'a3', orientation: 'portrait' }, // Set the document format and orientation (optional)
      pagebreak: { mode: ['avoid-all', 'css', 'legacy'] } //Sets Page Break (optional)
    };

    await html2pdf().set(options).from(contentClone).save('VocabularyStudySheet.pdf');
  };

  if (pageLoader) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ height: '40px' }}>
        <HesSpinner />
        <span className="ms-3">Loading results...</span>
      </div>
    );
  }

  return (
    <div className="white-card" id="session_pdf_Wrapper">
      <div className="student_response_header">
        <div>
          <h3>Vocabulary Study Sheet</h3>
        </div>
        <div className="d-flex justify-content-between" style={{ width: '220px' }}>
          <button id="back_button" onClick={() => navigate(-1)} className="btn btn-width btn-castleWhite">
              Back
          </button>
          <button id="print_button" onClick={handlePrint}  className="btn btn-castleRed">
              Print to PDF
          </button>
        </div>
      </div>
      <div className="student_response_details">
        <div className="d-flex justify-content-between">
          <div className="student_response_details_left">
            <p>
                Assignment: <strong>{vocabulary.assignmentName}</strong>
            </p>
            <p>
                Course: <strong>{vocabulary.courseName}</strong>
            </p>
            <p>
                Teacher: <strong>{vocabulary.teacherName}</strong>
            </p>
          </div>
          <div className="student_response_details_right" style={{justifyContent:'normal'}}>
            <p>
                School: <strong>{vocabulary.schoolName}</strong>
            </p>
            <p>
                Report Date: <strong>{vocabulary.reportDate}</strong>
            </p>
          </div>
        </div>
      </div>

      {vocabularyData!=null ? vocabularyData?.map((item, index) => (
        <div className='vocab_container' key={`vocab-${index}`}>
          <div dangerouslySetInnerHTML={{ __html: item.name }} className='vocabInfoHeader pb-2'></div>
          <div dangerouslySetInnerHTML={{ __html: item.description }} className='vocabInfoDescription'></div>
        </div>   
      )):(
        <div className='vocab_container flex-center-align'>
          <p>No Vocabulary terms.</p>
        </div>
      )}
    </div>
  );
};

export default VocabularyStudySheet;